type MobileContact = {
  name: string;
  role: string;
  telephone: string;
};

type BranchHours = {
  opensAt: number;
  closesAt: number;
};

type LicenseeType = {
  id: number;
  code: string;
  name: string;
  vat: string;
};

type Branch = {
  id: number;
  name: string;
  city: string;
  deliveryMethods: string[];
  addressDescription: string;
  latitude: number;
  longitude: number;
  distance?: number;
  isOpen: boolean;
  estimatedWaitingTime: number;
  openingHours: BranchHours[];
  mobileContacts: MobileContact[];
  licensee: LicenseeType;
};

type BranchDisplay = {
  id: number;
  name: string;
  city: string;
  addressDescription: string;
  latitude: number;
  longitude: number;
  distance: number;
  isOpen: boolean;
  waitingTime: number;
  opensAt?: string;
  closesAt?: string;
};

export type { Branch, BranchDisplay, BranchHours, LicenseeType, MobileContact };
